import { render, staticRenderFns } from "./logs2.vue?vue&type=template&id=6b4ac382"
import script from "./logs2.vue?vue&type=script&lang=js"
export * from "./logs2.vue?vue&type=script&lang=js"
import style0 from "./logs2.vue?vue&type=style&index=0&id=6b4ac382&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports